"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventAction = void 0;
/**
 * This file was generated and subsequently committed to source via TypescriptUserFacingStringsGenerator.
 * Do not modify this file directly. If updates are required, update the utility as necessary and re-run it.
 */
var EventAction;
(function (EventAction) {
    EventAction["ApplicationRead"] = "application-read";
    EventAction["ApplicationReadBlocked"] = "application-read-blocked";
    EventAction["FileCreated"] = "file-created";
    EventAction["FileDeleted"] = "file-deleted";
    EventAction["FileDownloaded"] = "file-downloaded";
    EventAction["FileEmailed"] = "file-emailed";
    EventAction["FileInventoried"] = "file-inventoried";
    EventAction["FileModified"] = "file-modified";
    EventAction["FileShared"] = "file-shared";
    EventAction["GitClone"] = "git-clone";
    EventAction["GitFetch"] = "git-fetch";
    EventAction["GitPull"] = "git-pull";
    EventAction["GitPush"] = "git-push";
    EventAction["Heartbeat"] = "heartbeat";
    EventAction["Printed"] = "printed";
    EventAction["RemovableMediaAdded"] = "removable-media-added";
    EventAction["RemovableMediaBlocked"] = "removable-media-blocked";
    EventAction["RemovableMediaCreated"] = "removable-media-created";
    EventAction["RemovableMediaDeleted"] = "removable-media-deleted";
    EventAction["RemovableMediaModified"] = "removable-media-modified";
    EventAction["RemovableMediaRemoved"] = "removable-media-removed";
    EventAction["SyncAppCreated"] = "sync-app-created";
    EventAction["SyncAppDeleted"] = "sync-app-deleted";
    EventAction["SyncAppModified"] = "sync-app-modified";
    EventAction["FileMoved"] = "file-moved";
    EventAction["FileRenamed"] = "file-renamed";
    EventAction["RemovableMediaMoved"] = "removable-media-moved";
    EventAction["RemovableMediaRenamed"] = "removable-media-renamed";
    EventAction["SyncAppMoved"] = "sync-app-moved";
    EventAction["SyncAppRenamed"] = "sync-app-renamed";
    EventAction["BrowserPaste"] = "browser-paste";
    EventAction["BrowserPasteBlocked"] = "browser-paste-blocked";
    EventAction["NetworkStorageCreated"] = "network-storage-created";
    EventAction["NetworkStorageDeleted"] = "network-storage-deleted";
    EventAction["NetworkStorageModified"] = "network-storage-modified";
    EventAction["NetworkStorageRenamed"] = "network-storage-renamed";
})(EventAction = exports.EventAction || (exports.EventAction = {}));
